import {
  REORDERABLE_USER_INFO_COLUMN_KEYS,
  UserInfoColumnKey,
} from '../../constants/user-info-columns';
import { DEFAULT_USER_INFO_VISIBILITY } from '../persistence/user-info-defaults';
import { PlannerSliceCreator, UserInfoColumnsSlice, UserInfoVisibilityProperty } from '../types';

/**
 * Member-info column visibility/order and collapsed timeline groups. Persistence
 * happens through the store-wide persist partialize (persistence/persisted-state.ts)
 * — never write localStorage here. Initial values are plain defaults; hydration
 * (persistence/hydration.ts) overrides them from storage/legacy keys.
 */
export const createUserInfoColumnsSlice: PlannerSliceCreator<UserInfoColumnsSlice> = set => ({
  userInfoVisibility: DEFAULT_USER_INFO_VISIBILITY,
  toggleUserInfoProperty: (property: UserInfoVisibilityProperty) =>
    set(state => ({
      userInfoVisibility: {
        ...state.userInfoVisibility,
        [property]: !state.userInfoVisibility[property],
      },
    })),
  toggleCustomAttributeVisibility: (attributeId: number) =>
    set(state => {
      const key = String(attributeId);
      return {
        userInfoVisibility: {
          ...state.userInfoVisibility,
          customAttributes: {
            ...state.userInfoVisibility.customAttributes,
            [key]: !state.userInfoVisibility.customAttributes[key],
          },
        },
      };
    }),

  userInfoOrder: [...REORDERABLE_USER_INFO_COLUMN_KEYS],
  setUserInfoOrder: (order: UserInfoColumnKey[]) =>
    set(state =>
      JSON.stringify(state.userInfoOrder) === JSON.stringify(order)
        ? state
        : { userInfoOrder: order }
    ),

  collapsedGroups: new Set<string>(),
  toggleGroupCollapse: (groupId: string) =>
    set(state => {
      const newCollapsedGroups = new Set(state.collapsedGroups);
      if (newCollapsedGroups.has(groupId)) {
        newCollapsedGroups.delete(groupId);
      } else {
        newCollapsedGroups.add(groupId);
      }

      return { collapsedGroups: newCollapsedGroups };
    }),
  resetCollapsedGroups: () => set({ collapsedGroups: new Set<string>() }),
});
